import React, { useContext, useState } from 'react';
import { StateContext } from '../../StateContext';
import { TextField } from '@mui/material';
import { registerUserCall } from '../../Services/APICalls/apicalls';
import PasswordField from './password';
import { PageItems } from '../index';
import { useLanguage } from '../../Services/LanguageContext';
import './login.css';

const RegisterPage = () => {
    const [password1, setPassword1] = useState('');
    const [password2, setPassword2] = useState('');
    const [userName, setUserName] = useState('');
    const [regCode, setRegCode] = useState('');
    const { t, language, setLanguage } = useLanguage();

    const { setLoginData, setPage } = useContext(StateContext);

    const registerUserHandler = async (e: React.FormEvent) => {
        e.preventDefault();
        if (password1 !== password2) return alert(t('passwordsDoNotMatch'));
        await registerUserCall(userName, password1, regCode, setLoginData);
        window.location.reload();
    };

    const goToLogin = () => {
        setPage(PageItems.LOGIN);
    };

    return (
        <div className='login-container'>
            <button
                className='login-lang-toggle'
                onClick={() => setLanguage(language === 'nl' ? 'en' : 'nl')}
                title={t('switchToLanguage')}
            >
                {language === 'nl' ? '🇬🇧 EN' : '🇳🇱 NL'}
            </button>

            <div className='login-card'>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <img
                        className='login-logo'
                        src='https://www.j-twee.nl/wp-content/themes/jtwee/img/logo.png'
                        alt='Logo'
                    />
                    <h1 className='login-title'>{t('register')}</h1>
                    <p className='login-subtitle'>
                        {t('createNewAccount')}
                    </p>
                </div>

                <form className='login-form' onSubmit={registerUserHandler} action='#'>
                    <TextField
                        label={t('username')}
                        type='text'
                        variant='outlined'
                        value={userName}
                        onChange={(x) => setUserName(x.target.value)}
                        fullWidth
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                background: 'var(--bg-tertiary)',
                            },
                        }}
                    />
                    <PasswordField value={password1} onChange={setPassword1} />
                    <PasswordField value={password2} onChange={setPassword2} />
                    <TextField
                        label={t('registrationCode')}
                        type='text'
                        variant='outlined'
                        value={regCode}
                        onChange={(x) => setRegCode(x.target.value)}
                        fullWidth
                        inputProps={{ maxLength: 4 }}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                                background: 'var(--bg-tertiary)',
                            },
                        }}
                    />
                    <button type='submit' className='btn-login'>
                        {t('register')}
                    </button>
                </form>

                <div className='login-divider'>
                    {t('or')}
                </div>

                <button onClick={goToLogin} className='btn-register'>
                    {t('backToLogin')}
                </button>
            </div>
        </div>
    );
};

export default RegisterPage;
